import { render, staticRenderFns } from "./EditActive.vue?vue&type=template&id=12ee5372&"
import script from "./EditActive.vue?vue&type=script&lang=js&"
export * from "./EditActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports